import styled from 'styled-components';
export default styled.h1.withConfig({
  displayName: "Title",
  componentId: "sc-11dc4ql-0"
})(["letter-spacing:1.5px;color:", ";text-transform:", ";display:inline-block;font-size:32px;line-height:1.2;text-align:center;margin:0 auto;max-width:95%;position:relative;z-index:2;@media screen and (min-width:800px){font-size:60px;line-height:1.166666;max-width:1000px;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.landingSectionTitleColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.landingSectionTitleBackgroundColor ? "\n  line-height: 1.4;\n  span {\n    background: " + theme.landingSectionTitleBackgroundColor + ";\n    line-height: 1.4;\n    padding: 0 0.25em;\n    box-decoration-break: clone;\n  }\n  " : null;
});